<template>
  <div>
    <div
      class="form-check" :class="[formCheckFillPattern, { disabled: disabled }, inlineClass]">
      <label :for="cbId" class="form-check-label">
        <input
          :id="cbId"
          class="form-check-input"
          type="radio"
          :disabled="disabled"
          :value="name"
          v-model="model"/>
        <span class="form-check-sign"></span><slot></slot>
      </label>
    </div>
  </div>
</template>
<script>

export default {
  name: 'base-radio',
  props: {
    name: {
      type: [String, Number],
      description: 'Radio label'
    },
    disabled: {
      type: Boolean,
      description: 'Whether radio is disabled'
    },
    value: {
      type: [String, Boolean, Number],
      description: 'Radio value'
    },
    textValue: {
      type: String
    },
    inline: {
      type: Boolean,
      description: 'Whether radio is inline'
    },
    isDarkMode: Boolean,
    isDesktop: Boolean,
    radioFillbyMode: {
      type: Number,
      default: 1,
      description: 'Whether to change the appearance of the selected radio button to a [almost] fully-filled circle via the triggering of a mobile or dark mode environment'
    },
  },
  data() {
    return {
      cbId: '',
      radioFillbyTypes: { byDesktopMode: 1, byDarkMode: 2 },
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
      return '';
    },
    isChecked() {
      return this.value === this.name;
    },
    formCheckFillPattern() {
      return (this.radioFillbyMode === this.radioFillbyTypes.byDesktopMode && this.isDesktop) || (this.radioFillbyMode === this.radioFillbyTypes.byDarkMode && !this.isDarkMode) 
        ? 'form-check-radio' : 'form-check-radio-full';
    }
  },
  created() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2);
  }
};
</script>
<style scoped>
.form-check-inline {
  margin-right: 0px;
}
.form-check-inline .form-check-input {
  margin-right: 0px;
}
.form-check-radio.form-check-inline .form-check-label, .form-check-radio-full.form-check-inline .form-check-label {
  margin-right: 0px;
}
</style>
